module.exports = __webpack_public_path__ + "static/media/cl2-icon-edit.aa16bceb.svg";